module.exports = __webpack_public_path__ + "assets/img/blast_label.61dc2a0f.png";